import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {injectIntl, intlShape, defineMessages} from 'react-intl';
import {VM} from '@hetao/scratch-core';
import JSZip from 'jszip';

// import analytics from '../lib/analytics';
import spriteLibraryContent from '../lib/libraries/sprites.json';
import spriteTags from '../lib/libraries/sprite-tags';

import LibraryComponent from '../components/library/library.jsx';
import {handleFileUpload, spriteUpload} from '../lib/file-uploader';
import {openPaintEditor, closeSpriteLibrary} from '../reducers/modals';
import {showStandardAlert, closeAlertWithId} from '../reducers/alerts';
import sharedMessages from '../lib/shared-messages';
import {emptySprite} from '../lib/empty-assets';
import {getImgWidthAndHeight,getIsValidImgWidthAndHeight, getIsTeacherMode, isImageSizeWithinLimits} from '../utils/tools'

const messages = defineMessages({
    libraryTitle: {
        defaultMessage: 'Choose a Sprite',
        description: 'Heading for the sprite library',
        id: 'gui.spriteLibrary.chooseASprite'
    }
});

class SpriteLibrary extends React.PureComponent {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleFileUploadClick',
            'handleItemSelect',
            'handleMouseEnter',
            'handleMouseLeave',
            'handleNewSprite',
            'handlePaintClick',
            'handleSpriteUpload',
            'rotateCostume',
            'startRotatingCostumes',
            'stopRotatingCostumes',
            'setFileInput'
        ]);
        this.state = {
            activeSprite: null,
            costumeIndex: 0,
            sprites: spriteLibraryContent
        };
    }
    componentWillUnmount () {
        clearInterval(this.intervalId);
    }
    handleItemSelect (item) {
        this.props.vm.addSprite(JSON.stringify(item.json));
        // analytics.event({
        //     category: 'library',
        //     action: 'Select Sprite',
        //     label: item.name
        // });
    }
    handleMouseEnter (item) {
        this.stopRotatingCostumes();
        this.setState({activeSprite: item}, this.startRotatingCostumes);
    }
    handleMouseLeave () {
        this.stopRotatingCostumes();
    }
    startRotatingCostumes () {
        if (!this.state.activeSprite) return;
        this.rotateCostume();
        this.intervalId = setInterval(this.rotateCostume, 300);
    }
    stopRotatingCostumes () {
        this.intervalId = clearInterval(this.intervalId);
    }
    rotateCostume () {
        const costumes = this.state.activeSprite.json.costumes;
        const nextCostumeIndex = (this.state.costumeIndex + 1) % costumes.length;
        this.setState({
            costumeIndex: nextCostumeIndex,
            sprites: this.state.sprites.map(sprite => {
                // not enough merely judge the key of 'name'.
                // because there may be more than 1 sprites have the same value to the same name.
                // so I add two more conditions to judge if it is the matched obj. qjn added
                if (sprite.name === this.state.activeSprite.name &&
                    sprite.json.costumes.length === this.state.activeSprite.json.costumes.length &&
                    sprite.json.costumes[0].baseLayerMD5 === this.state.activeSprite.json.costumes[0].baseLayerMD5
                ) {
                    return {
                        ...sprite,
                        md5: sprite.json.costumes[nextCostumeIndex].baseLayerMD5
                    };
                }
                return sprite;
            })
        });
    }
    handleNewSprite (spriteJSONString) {
        return this.props.vm.addSprite(spriteJSONString)
            .then(this.handleActivateBlocksTab);
    }
    handleFileUploadClick () {
        this.fileInput.click();
    }
    async checkImageInBlob(blob){
        let valid = true;
        let isPresentedConfirm = false;
        const checkImage = async (image,name)=>{
            const {width,height} = await getImgWidthAndHeight(image);
                if (!getIsValidImgWidthAndHeight(width,height)) {
                    alert((name || image.name)+'图片宽高不符合unity3d要求的标准，需要被4整除！'); 
                    valid = false;
                }

                // 避免上传 sprite3 时重复弹窗
                if (!isPresentedConfirm && !isImageSizeWithinLimits(width, height)) {
                    isPresentedConfirm = true;
                    valid = confirm((name || image.name)+' 图片宽高已超过 480 x 360，可能会导致低端设备崩溃，是否确定上传？');
                }
        };
        //如果角色直接上传的图片
        if (blob.type.includes('image/')) {
            await checkImage(blob);
            return valid;
        }
        const zip = new JSZip();
        //如果角色上传的是sprite3
        await zip.loadAsync(blob);
        for (const name in zip.files) {
            const extensions = ['png', 'jpg', 'jpeg', 'gif'];
            const extensionRegexes = extensions.map(extName => new RegExp(`${extName}$`, 'i'));
            if (extensionRegexes.some(extRegex => extRegex.test(name))) {
                const file = await zip.file(name).async('blob');
                await checkImage(file, name);
            }       }
        return valid;
    }
    handleSpriteUpload (e) {
        const storage = this.props.vm.runtime.storage;
        this.props.onShowImporting();
        handleFileUpload(e.target, async (blob, fileType, fileName, fileIndex, fileCount) => {
            if (getIsTeacherMode()){
                const isValid = await this.checkImageInBlob(blob);
                if (!isValid){
                    return;
                }
            }
            spriteUpload(blob, fileType, fileName, storage, newSprite => {
                this.handleNewSprite(newSprite).then(() => {
                    if (fileIndex === fileCount - 1) {
                        this.props.onCloseImporting();
                    }
                });
            }, this.props.onCloseImporting);
        }, this.props.onCloseImporting);
    }
    setFileInput (input) {
        this.fileInput = input;
    }
    handlePaintClick () {
        // @todo this is brittle, will need to be refactored for localized libraries
        const formatMessage = this.props.intl.formatMessage;
        const emptyItem = emptySprite(
            formatMessage(sharedMessages.sprite, {index: 1}),
            formatMessage(sharedMessages.pop),
            formatMessage(sharedMessages.costume, {index: 1})
        );
        this.props.vm.addSprite(JSON.stringify(emptyItem)).then(() => {
            setTimeout(() => { // Wait for targets update to propagate before tab switching
                this.props.onPaintClick();
            });
        });
    }
    render () {
        return (
            <LibraryComponent
                data={this.state.sprites}
                fileAccept={'.svg, .png, .jpg, .jpeg, .sprite2, .sprite3, .gif'}
                fileInputRef={this.setFileInput}
                id="spriteLibrary"
                tags={spriteTags}
                title={this.props.intl.formatMessage(messages.libraryTitle)}
                onFileUploadClick={this.handleFileUploadClick}
                onItemMouseEnter={this.handleMouseEnter}
                onItemMouseLeave={this.handleMouseLeave}
                onItemSelected={this.handleItemSelect}
                onPaintClick={this.handlePaintClick}
                onRequestClose={this.props.onRequestClose}
                onSpriteUpload={this.handleSpriteUpload}
            />
        );
    }
}

SpriteLibrary.propTypes = {
    intl: intlShape.isRequired,
    onCloseImporting: PropTypes.func,
    onPaintClick: PropTypes.func,
    onRequestClose: PropTypes.func,
    onShowImporting: PropTypes.func,
    vm: PropTypes.instanceOf(VM).isRequired
};

const mapDispatchToProps = dispatch => ({
    onPaintClick: () => {
        dispatch(openPaintEditor());
        dispatch(closeSpriteLibrary());
    },
    onCloseImporting: () => dispatch(closeAlertWithId('importingAsset')),
    onShowImporting: () => dispatch(showStandardAlert('importingAsset'))
});

export default injectIntl(
    connect(
        null, mapDispatchToProps
    )(SpriteLibrary)
);
